var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import FetchService from "./Shared/FetchService";
import PersonAlertService from "../Domain/PersonAlert/PersonAlert.service";
const baseURL = "/aviso/alert";
export default class AlertService {
    static getEarlyAlert(personTypeName, recipientIds) {
        return FetchService.getSingleResponse(baseURL + "/getEarlyAlert", {
            personTypeName,
            recipientIds,
        });
    }
    static getEarlyAlertNotificationRecipients(studentAffId, earlyAlertReasonId) {
        return FetchService.getSingleResponse(baseURL + "/getEarlyAlertNotificationRecipients", { studentAffId, earlyAlertReasonId });
    }
    static getEligibleRecipients(searchText, max, offset) {
        return FetchService.getSingleResponse(baseURL + "/getEligibleRecipients", {
            searchText,
            max,
            offset,
        });
    }
    static search(searchText, max, offset) {
        return FetchService.getPagedResponse(baseURL + "/search", {
            query: searchText,
            max,
            offset,
        });
    }
    static getPersonAlert(personAlertId) {
        return FetchService.getSingleResponse("/aviso/advisor/getPersonAlert", {
            alertId: personAlertId,
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => PersonAlert' is not assignable to parameter of type '(value: unknown) => PersonAlert | PromiseLike<PersonAlert>'.
        }).then(PersonAlertService.fromJSON);
    }
    static closeAlert(personAlertId, optional = {}) {
        return FetchService.postSingleResponse("/aviso/advisor/closeAlert", {
            alertId: personAlertId,
            outreachId: optional.outreachId,
            comment: optional.comment,
            sendCommentInEmailToCreator: optional.sendCommentInEmailToCreator,
            markAcademicPlanTermOnPlan: optional.markAcademicPlanTermOnPlan,
            // @ts-expect-error - TS2345 - Argument of type '(json: { [key: string]: any; }) => PersonAlert' is not assignable to parameter of type '(value: unknown) => PersonAlert | PromiseLike<PersonAlert>'.
        }).then(PersonAlertService.fromJSON);
    }
    static getEarlyAlertReasons(personTypeName) {
        return FetchService.getSingleResponse(baseURL + "/getEarlyAlertReasons", {
            personTypeName,
        });
    }
    static createManualAlert({ students, earlyAlertReasonId, courseSectionId, selectedRecipients, text, internalComment, }) {
        return FetchService.postSingleResponse(baseURL + "/createManualAlert", {
            affiliationId: students,
            earlyAlertReasonId,
            courseSectionId,
            recipients: selectedRecipients,
            text,
            internalComment,
        });
    }
    static sendToOpportunity({ opportunityId, earlyAlertReasonId, recipientIds, text, internalComment, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(baseURL + "/sendToOpportunity", {
                opportunityId,
                earlyAlertReasonId,
                recipientIds,
                text,
                internalComment,
            });
        });
    }
    static sendToOpportunities({ opportunityIds, earlyAlertReasonId, text, internalComment, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(baseURL + "/sendToOpportunities", {
                opportunityIds,
                earlyAlertReasonId,
                text,
                internalComment,
            });
        });
    }
    static sendToPersonPopulation({ earlyAlertReasonId, populationId, text, internalComment, }) {
        return __awaiter(this, void 0, void 0, function* () {
            return FetchService.postSingleResponse(baseURL + "/sendToPersonPopulation", {
                populationId,
                earlyAlertReasonId,
                text,
                internalComment,
            });
        });
    }
    static isAlertConfiguredForStudentEmail(alertId, earlyAlertReasonId) {
        return FetchService.getSingleResponse(baseURL + "/isAlertConfiguredForStudentEmail", { alertId, earlyAlertReasonId });
    }
}
